import ChevronDown from '../assets/svgs/ChevronDown'

export default function Title({ scrollElements, executeScroll }) {
	return (
		<section
			ref={scrollElements.home}
			className='text-center flex-col justify-center slide relative'
		>
			<h1 className='select-none'>Ronny Victor</h1>
			<h2>Graphic Designer & Web Developer</h2>
			<div className='flex justify-center absolute w-full bottom-8'>
				<button
					onClick={() => executeScroll(scrollElements.graphicDesign)}
					className='check-out-btn'
				>
					<div className='pb-1'>Check Out My Work</div>
					<ChevronDown />
				</button>
			</div>
		</section>
	)
}
